<template>
  <div class="order-linked-orders">
    <div class="columns">
      <div class="column">
        <!-- Assign Parent -->
        <div class="field" v-if="!order.parentOrder && canAttachParent">
          <div class="field-body">
            <b-field>
              <b-autocomplete
                expanded
                v-model="selectedParent"
                :data="parentOrders"
                placeholder="Search for orders to be linked..."
                field="orderId"
                :loading="loading"
                :disabled="!order.editable"
                @typing="query => getOrdersParent(query)"
              ></b-autocomplete>
              <p class="control">
                <button
                  class="button is-info"
                  :disabled="loading || !order.editable"
                  @click="assignParent"
                >ATTACH PARENT</button>
              </p>
            </b-field>
          </div>
        </div>

        <!-- Link Order -->
        <div class="field">
          <div class="field-body">
            <b-field>
              <b-autocomplete
                expanded
                v-model="autocomplete.linkWO.model"
                :data="autocomplete.linkWO.data"
                placeholder="Search for orders to be linked..."
                field="orderId"
                :loading="autocomplete.linkWO.loading"
                @typing="query => getOrders(query, 'linkWO')"
                :disabled="!order.editable"
              ></b-autocomplete>
              <p class="control">
                <button
                  class="button is-info "
                  :disabled="!autocomplete.linkWO.model || loading "
                  @click="link"
                >ASSOCIATE ORDER</button>
              </p>
            </b-field>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-three-fifths">
        <order-family-tree :order="order" ref="familyTree"/>
      </div>
      <div class="column has-text-centered">
        <h2 class="subtitle">ASSOCIATED ORDERS</h2>
        <ul class="friends">
          <li v-for="linkedOrder in linkedOrders" :key="linkedOrder.id">

            <router-link :to="{ name: 'order-list', query: { orderId: linkedOrder.orderId } }" class="has-text-link" style="text-align:left;">
              <p>Status: {{ linkedOrder.status }}</p>
              <p>Number: {{ linkedOrder.orderId }}</p>
              <p>Activity Type: {{ linkedOrder.activityType }}</p>
            </router-link>

          </li>
        </ul>
      </div>
    </div>
    <!-- <table class="table is-fullwidth">
      <tbody>
        <tr>
          <td>
            <order-family-tree :order="order" ref="familyTree"/>
          </td>
          <td class="has-text-centered">
            <h2 class="subtitle">Friends</h2>
            <ul class="friends">
              <li v-for="linkedOrder in linkedOrders" :key="linkedOrder.id">
                <router-link
                  :to="{ name: 'order-list', query: { orderId: linkedOrder.orderId } }"
                  class="has-text-link"
                >{{ linkedOrder.orderId }}</router-link>
              </li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>-->
  </div>
</template>

<script>
import { OrderService } from "@/services/order.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
import OrderFamilyTree from "./OrderFamilyTree";
import debounce from "lodash/debounce";

export default {
  orderService: OrderService,
  props: {
    order: {
      required: true
    }
  },

  components: {
    OrderFamilyTree
  },
  data: () => ({
    linkedOrders: [],
    autocomplete: {
      linkWO: {
        model: "",
        data: [],
        loading: false,
        timeout: null
      }
    },
    loading: false,
    parentOrders: [],
    selectedParent: null
  }),
  created() {
    this.fetch();
  },
  watch: {
    linkedOrders(orders) {
      this.$emit("update:linkedOrders", orders);
    }
  },
  computed:{
    canAttachParent(){
      return this.$store.getters["Auth/hasFirmPermission"]("can manually attach parent orders");
    }
  },
  methods: {
    async fetch() {
      if (this.order) {
        try {
          this.linkedOrders = await this.$options.orderService
            .listLinkedOrders(this.order.id)
            .then(resposne => JsonDenormalizer.denormalize(resposne.data));
        } catch (err) {}
      }
    },
    getOrders(search, key) {
      if (this.autocomplete[key].timeout) {
        clearTimeout(this.autocomplete[key].timeout);
      }

      this.autocomplete[key].timeout = setTimeout(async () => {
        this.autocomplete[key].loading = true;

        try {
          const response = await this.$options.orderService.all({ search });

          this.autocomplete[key].data = JsonDenormalizer.denormalize(response);
        } catch (err) {}

        this.autocomplete[key].loading = false;
      }, 500);
    },
    getOrdersParent: debounce(function(search) {
      this.parentOrders = [];
      this.loading = true;
      this.$options.orderService.all({ search }).then(response => {
        // Loop Response
        response.data.forEach(order => {
          // Validate if Order Id is not null
          if (
            order.attributes.orderId != null ||
            order.attributes.orderId != ""
          ) {
            // Push order into parentOrders variable
            this.parentOrders.push(order.attributes.orderId);
          }
        });
        this.loading = false;
      });
    }, 500),
    async link() {
      this.loading = true;

      try {
        const response = await this.$options.orderService.link(
          this.order.id,
          this.autocomplete.linkWO.model
        );
        const data = JsonDenormalizer.denormalize(response.data);

        this.linkedOrders.push(data);

        this.autocomplete.linkWO.model = "";
        this.$buefy.toast.open({
          message: "Order has been linked.",
          type: "is-info",
          position: "is-top-right"
        });
      } catch (err) {}

      this.loading = false;
    },
    assignParent() {
      this.loading = true;
      let data = {
        orderId: this.selectedParent
      };
      this.$options.orderService
        .assignParent(this.order.id, data.orderId)
        .then(() => {
          this.$refs.familyTree.fetchNodes();
          this.loading = false;
          this.selectedParent = null;
          this.$buefy.toast.open({
            message: "Order has been assign as parent.",
            type: "is-info",
            position: "is-top-right"
          });
        });
    }
  }
};
</script>

<style lang="scss">
// Friend
.friends li {
  margin-bottom: 10px;
}
.friends li a {
  display: inline-block;
  padding: 5px 10px;

  border-radius: 5px;
  border: 1px solid #363636;

  text-decoration: none;
  text-transform: uppercase;
  color: #363636;
  font-family: arial, verdana, tahoma;
  font-size: 11px;
}

.friends li a:hover,
.friends li a:hover + ul li a {
  color: #000;
  background: #83c6f7;
  border: 1px solid #94a0b4;
}
// Family
.detail-family-tree {
  .menu-list a {
    display: initial;
  }
}

.family-tree {
  margin: 5px auto;
  width: 100%;
  min-height: auto;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}

.family-tree ul {
  position: relative;
  padding-top: 20px;
}

.family-tree li {
  position: relative;
  padding: 20px 3px 0 3px;
  float: left;

  text-align: center;
  list-style-type: none;
}

.family-tree li::before,
.family-tree li::after {
  content: "";
  position: absolute;
  top: 0;
  right: 50%;
  width: 50%;
  height: 20px;
  border-top: 1px solid #363636;
}

.family-tree li::after {
  left: 50%;
  right: auto;

  border-left: 1px solid #363636;
}

.family-tree li:only-child::after,
.family-tree li:only-child::before {
  content: "";
  display: none;
}

.family-tree li:only-child {
  padding-top: 0;
}
.family-tree li:first-child::before,
.family-tree li:last-child::after {
  border: 0 none;
}

.family-tree li:last-child::before {
  border-right: 1px solid #363636;
  border-radius: 0 5px 0 0;
}

.family-tree li:first-child::after {
  border-radius: 5px 0 0 0;
}
.family-tree ul ul::before {
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  border-left: 1px solid #363636;
  width: 0;
  height: 20px;
}

.family-tree li a {
  display: inline-block;
  padding: 5px 10px;

  border-radius: 5px;
  border: 1px solid #363636;

  text-decoration: none;
  text-transform: uppercase;
  color: #363636;
  font-family: arial, verdana, tahoma;
  font-size: 11px;
}

.family-tree li a:hover,
.family-tree li a:hover + ul li a {
  color: #000;
  background: #83c6f7;
  border: 1px solid #94a0b4;
}

.family-tree li a:hover + ul li::after,
.family-tree li a:hover + ul li::before,
.family-tree li a:hover + ul::before,
.family-tree li a:hover + ul ul::before {
  content: "";
  border-color: #94a0b4;
}
.family-tree li a.active {
  background: #83c6f7;
}
</style>



// WEBPACK FOOTER //
// src/components/Order/OrderLinkedOrders.vue